import { createSlice } from "@reduxjs/toolkit";

export const name = "zsearch";

export const zsearchSlice = createSlice({
  name,
  initialState: {
    mgwDevices: [],
    pefEndpoints: [],
    mgwDevicesLoading: false,
    mgwLogs: [],
    mgwLogsLoading: false,
    pefDevices: [],
    pefDevicesLoading: false,
    pefLogs: [],
    pefLogsLoading: false,
    dashboardData: {
      totalEmails: 0,
      statusCounts: {},
      senderDomains: [],
      senderDomainsSample: 0,
      emailVolume: {},
      hourlyVolume: [],
      avgDelay: 0,
      blockedHeld: 0,
      failures: { count: 0, rate: 0, approximate: false, items: [] },
      procHealth: {},
    },
    dashboardAlerts: [],
    dashboardDataLoading: false,
    dashboardHealthLoading: false,
  },
  reducers: {
    RequestIndexes: (state) => {
      state.mgwDevicesLoading = true;
    },
    SuccessIndexes: (state, action) => {
      const { index, indexes } = action.payload;
      if (index === "postfix.") {
        state.mgwDevices = indexes;
      } else if (index === "cf-sb1") {
        state.pefEndpoints = indexes;
      }
      state.mgwDevicesLoading = false;
    },
    FailureIndexes: (state, action) => {
      const index = action.payload;
      if (index === "postfix.") {
        state.mgwDevices = [];
      } else if (index === "cf-sb1") {
        state.pefEndpoints = [];
      }
      state.mgwDevicesLoading = false;
    },
    RequestMailGatewayLogs: (state) => {
      state.mgwLogsLoading = true;
    },
    SuccessMailGatewayLogs: (state, action) => {
      state.mgwLogs = action.payload;
      state.mgwLogsLoading = false;
    },
    FailureMailGatewayLogs: (state) => {
      state.mgwLogs = [];
      state.mgwLogsLoading = false;
    },
    RequestPefDevices: (state) => {
      state.pefDevicesLoading = true;
    },
    SuccessPefDevices: (state, action) => {
      state.pefDevices = action.payload;
      state.pefDevicesLoading = false;
    },
    FailurePefDevices: (state) => {
      state.pefDevices = [];
      state.pefDevicesLoading = false;
    },
    RequestPefLogs: (state) => {
      state.pefLogsLoading = true;
    },
    SuccessPefLogs: (state, action) => {
      state.pefLogs = action.payload;
      state.pefLogsLoading = false;
    },
    FailurePefLogs: (state) => {
      state.pefLogs = [];
      state.pefLogsLoading = false;
    },
    RequestDashboardData: (state) => {
      state.dashboardDataLoading = true;
    },
    SuccessDashboardData: (state, action) => {
      const { dashboardData, dashboardAlerts } = action.payload;
      state.dashboardData = { ...state.dashboardData, ...dashboardData };
      state.dashboardAlerts = dashboardAlerts;
      state.dashboardDataLoading = false;
    },
    FailureDashboardData: (state) => {
      state.dashboardData = {
        totalEmails: 0,
        statusCounts: {},
        senderDomains: [],
        senderDomainsSample: 0,
        emailVolume: {},
        hourlyVolume: [],
        avgDelay: 0,
        blockedHeld: 0,
        failures: { count: 0, rate: 0, approximate: false, items: [] },
        procHealth: state.dashboardData.procHealth,
      };
      state.dashboardAlerts = [];
      state.dashboardDataLoading = false;
    },
    RequestDashboardHealth: (state) => {
      state.dashboardHealthLoading = true;
    },
    SuccessDashboardHealth: (state, action) => {
      state.dashboardData = { ...state.dashboardData, procHealth: action.payload };
      state.dashboardHealthLoading = false;
    },
    FailureDashboardHealth: (state) => {
      state.dashboardData = { ...state.dashboardData, procHealth: {} };
      state.dashboardHealthLoading = false;
    },
  },
});

export default zsearchSlice;
